module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-5ed509e6085831e89c3226f4556832e8.png";